export default "__VITE_ASSET__CgKg$7qS__"